import type { FC } from 'react';

// eslint-disable-next-line no-restricted-imports
import { Button } from '@mui/material';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

const buttonStyles: SxProps<Theme> = {
  width: 250,
  display: 'flex',
  justifyContent: 'flex-start',
  textTransform: 'none',
  backgroundColor: 'rgba(248, 248, 248, 0.20)',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: 'rgba(248, 248, 248, 0.50)'
  },
  '.MuiButton-startIcon': {
    svg: {
      marginRight: 0
    }
  }
};

export const GrayLinkButton: FC<any> = ({ sx, ...props }) => {
  return (
    <Button
      sx={[buttonStyles, ...normalizeSx(sx)]}
      {...props}
    />
  );
};
